const QQ_LINK_SELECTOR = 'a[href="#"]';

function findInPath(e, selector) {
  const path = (typeof e.composedPath === 'function') ? e.composedPath() : [];
  for (const el of path) {
    if (el && el.matches && el.matches(selector)) return el;
  }
  return null;
}

function getDialog() {
  return document.querySelector('#quick-quote-dialog dialog');
}

function toggleSections(mode) {
  const catalogo = document.querySelector('.qq-mode--catalogo');
  const custom = document.querySelector('.qq-mode--custom');

  const items = document.getElementById('qq-items');
  const qty = document.getElementById('qq-qty');
  const desc = document.getElementById('qq-desc');
  const customType = document.getElementById('qq-custom-type');

  if (catalogo) catalogo.hidden = true;
  if (custom) custom.hidden = true;

  if (items) items.required = false;
  if (qty) qty.required = false;
  if (desc) desc.required = false;
  if (customType) customType.required = false;

  if (mode === 'catalogo') {
    if (catalogo) catalogo.hidden = false;
    if (items) items.required = true;
    if (qty) qty.required = true;
  }

  if (mode === 'custom') {
    if (custom) custom.hidden = false;
    if (customType) customType.required = true;
    if (desc) desc.required = true;
  }
}

// CLICK open/close (capture = true per non perderlo nei componenti)
document.addEventListener('click', (e) => {
  const openEl =
    findInPath(e, '[data-qq-open]') ||
    findInPath(e, 'a[href="#"]');

  const closeEl = findInPath(e, '[data-qq-close]');

  if (openEl) {
    e.preventDefault();
    const dialog = getDialog();
    if (dialog && !dialog.open) dialog.showModal();

    const modeSel = document.getElementById('qq-mode');
    if (modeSel) {
      modeSel.value = '';
      toggleSections('');
    }
    return;
  }

  if (closeEl) {
    e.preventDefault();
    const dialog = getDialog();
    if (dialog && dialog.open) dialog.close();
  }
}, true);

// CHANGE modalità
document.addEventListener('change', (e) => {
  if (e.target && e.target.id === 'qq-mode') {
    toggleSections(e.target.value);
  }
});
